export default __webpack_public_path__ + "4591a513350fc7d49826cf3a0be15ec0.svg";